import React, { useState } from 'react'
import { connect } from 'react-redux'
import loadSheet from '../actionCreators/loadSheet'
import selectSheet from '../actionCreators/selectSheet'
import dismissModal from '../actionCreators/dismissModal'
import Modal from 'live/components/ui/Modal'
import { Button } from 'react-bootstrap'
import uploadSheetModel from '../actionCreators/uploadSheetModel'
import getDatabaseHeaders from '../actionCreators/getDatabaseHeaders'

import styled from 'styled-components'

interface Props {
    uploadModalTab: boolean
    dismissModal: () => void
    sheetData: object[]
    eventType: string
    fileName: string
    dateReference: boolean
    uploadSheetModel: (eventType: string, fileName: string, sheetIndex: number, date: string) => void
    getDatabaseHeaders: (eventType: string) => void
}

function SelectSpreadsheetTab({ uploadModalTab, dismissModal, sheetData, eventType, fileName, dateReference = false, uploadSheetModel, getDatabaseHeaders }: Props) {
    const [sheetIndex, setSheetIndex] = useState('')
    const [date, setDate] = useState('')
    const [dateReferenceError, setDatereferenceError] = useState<string>()

    const onChangeValue = (event) => {
        setSheetIndex(event.target.value)
    }

    const getEventTypePros = async eventType => {
        const response = await getDatabaseHeaders(eventType)
    }

    const submitModel = () => {
        uploadSheetModel(eventType, fileName, sheetIndex, date)
    }

    const checkDateReferenceAndSubmit = () => {
        if (dateReference) {
            if (!/^[0-9]{4}-[0-1][0-9]-[0-3][0-9]/.test(date)) {
                setDatereferenceError('invalid date format expected: yyyy-MM-dd')
                return 'invalid date format'
            }
        }

        submitModel()
        dismissModal()
    }

    const ReferenceInput = dateReference ? (
        <DateContainer>
            <label>File Date Reference</label>
            <InputContainer borderColor={dateReferenceError ? 'red' : '#C8CCD4'}>
                <i className="fal fa-calendar-alt"></i>
                <input
                    type="text"
                    value={date}
                    onChange={event => setDate(event.target.value)}
                    placeholder="YYYY-MM-DD"
                />
            </InputContainer>
            {dateReferenceError && (<p>{dateReferenceError}</p>)}
            <i className="far fa-info-circle"></i>
            <span>This will be used as a file reference</span>
        </DateContainer>
    ) : null

    return (
        <Container>
            <Modal show={uploadModalTab} onHide={dismissModal} onClose={dismissModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Select Spreadsheet Tab</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <RadioContainer onChange={onChangeValue}>
                        <p>
                            Select <strong>the tab</strong> you want to upload into:
                        </p>
                        <span className= "sheet-name"style={{
                            padding: '5px'
                        }}>{eventType}</span>
                        <div style={{
                            overflowY:'auto',
                            height: '300px',
                            padding: '5px'
                        }}>
                            {sheetData
                                ? sheetData.map((e, i) => (
                                    <label key={e?.sheetName} className="tab-select">
                                        <input id={e?.sheetName} type="radio" name="group" value={i} />
                                       <span className="tab-options">{e?.sheetName}</span>
                                    </label>
                                ))
                                : null}
                        </div>
                    </RadioContainer>
                    {ReferenceInput}
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        disabled={sheetIndex === '' && date?.length === 10 ? true : false}
                        bsStyle="primary"
                        onClick={() => {
                            checkDateReferenceAndSubmit()
                        }}
                    >
                        Upload
                    </Button>
                    <Button
                        bsStyle="default"
                        onClick={() => {
                            dismissModal()
                        }}
                    >
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container>
    )
}
const Container = styled.div`
    .fade.in.modal {
        display: flex !important;
    }

    .modal-dialog {
        margin: auto;
    }
`
const InputContainer = styled.div`
    width: 12.5rem;
    margin-bottom: 10px;
    position: relative;

    i {
        font-family: Font Awesome 5 Pro;
        position: absolute;
        padding: 10px;
        top: 50%;
        transform: translateY(-50%);
        right: 0;
        font-style: normal;
        font-weight: normal;
        font-size: 13px;
        line-height: 32px;
        color: var(--gray-600);
    }

    input {
        width: 100%;
        padding: 5px 18px 5px 5px;
        text-align: left;
        display: block;
        border: 1px solid ${props => props.borderColor};
    }
`
const DateContainer = styled.div`
    border-top: 1px solid var(--gray-400);
    padding: 16px 0;
    width: 100%;
    font-family: 'Source Sans Pro', sans-serif; 

    label {
        font-family: 'Source Sans Pro', sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 13px;
        line-height: 16px;

        color: var(--gray-800);

        &::after {
            content: ' *';
            color: red;
        }
    }

    span {
        font-family: 'Source Sans Pro', sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;
        color: var(--gray-700);
        margin: 0px 4px;
    }

    p {
        color: red;
    }
`

const RadioContainer = styled.div`
    font-family: Source Sans Pro;
    color: var(--gray-800);
    padding-bottom: 1rem;

    p {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
    }
    span {
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 16px;

        display: flex;
        align-items: center;

        color: var(--gray-800);

        
    }

    .sheet-name {
        font-family: 'Source Sans Pro', sans-serif; 
    }

    .tab-select{ 
        .tab-options{
            margin-top:-3px;
        }
    }


    label {
        margin-top: 1.7rem;
        display: flex;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 12px;

        color: var(--gray-800);

        input {
            margin-right: 5px;
        }
    }
`

function mapStateToProps({ sheet }) {
    const {
        uid,
        sheetData,
        selected,
        updatedSuccessfully,
        updateErrorMessage,
        importing,
        importedSuccessfully,
        importErrorMessage,
        uploadModalTab,
        dateReference
    } = sheet

    return {
        sheetData,
        uid,
        selected,
        updatedSuccessfully,
        updateErrorMessage,
        importing,
        importedSuccessfully,
        importErrorMessage,
        uploadModalTab,
        dateReference
    }
}

export default connect(mapStateToProps, { selectSheet, loadSheet, dismissModal, uploadSheetModel, getDatabaseHeaders })(
    SelectSpreadsheetTab
)
